import Head from 'next/head';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { NavBar } from 'components/shared/NavBar';
import Reinigung1 from '../public/images/Reinigung1.jpeg';
import Reinigung2 from '../public/images/Reinigung2.jpeg';
import Reinigung3 from '../public/images/Reinigung3.jpeg';
import Reinigung4 from '../public/images/Reinigung4.jpeg';

const Page = () => {
	return (
		<>
			<Head>
				<title>Pflege | Siccro Active Service</title>
				<meta
					name="description"
					content="Gereinigte Fenster sind eine gute Basis für ein angenehmes Wohnumfeld. Experten von SICCRO empfehlen, zusätzlich einige Pflegemaßnahmen durchzuführen, weil diese sich positiv auf die Lebensdauer auswirken und Ihnen dadurch Kosten sparen."
				/>
			</Head>
			<NavBar />
			<div className="mt-28 pb-10 container text-4xl text-center md:pt-12 font-black  md:text-5xl mx-auto">
				<h1>Reinigung für Fenster, Türen und Sonnenschutz</h1>
			</div>
			<div className=" max-w-[900px] text-xl pt-10 px-5 text-center flex flex-col mx-auto">
				<Image src={Reinigung1} className="flex rounded-lg flex-col mx-auto" height="900px" objectFit="cover" />
				<div className=" pb-10 text-2xl pt-10">
					<p>
						<b>
							Wenn die Sonne in Ihr Haus strahlt und die Zimmer mit ihrem Licht durchflutet, hebt das
							deutlich die Laune.
						</b>
						<br />
						<br />
						Umso störender ist es aber auch, wenn die Fensterscheiben verschmiert und voller Staub sind oder
						sich hartnäckiger Schmutz im Falzbereich sammelt.
					</p>
				</div>
				<div className="max-h-[900px] flex flex-col md:flex-row gap-3">
					<Image src={Reinigung3} className="w-full rounded-lg" objectFit="cover" />
					<Image src={Reinigung2} className="w-full rounded-lg" objectFit="cover" />
				</div>
				<div className="w-full">
					<h2 className="text-2xl py-5 font-black">Da hilft nur eines:</h2>
					<p>Der Schmutz muss schnellstens weg, um wieder einen klaren Durchblick zu bekommen.</p>
				</div>
				<h2 className="text-2xl py-5 font-black">Doch Fensterputzen will gelernt sein.</h2>
				<p>
					Denn oft steckt man viel Zeit und Mühe in die Reinigung der Fenster, doch die hässlichen Streifen
					und Schlieren verschwinden trotzdem nicht.
				</p>
				<h2 className="text-2xl  underline py-8 font-black">Es geht auch einfacher!</h2>
				<div className="max-h-[300px] flex flex-col md:flex-row ">
					<Image src={Reinigung4} className="w-full rounded-lg" objectFit="cover" />
				</div>
				<br />

				<h2 className="text-2xl py-5 font-black">
					Wir von Siccro sind Ihr Dienstleister für ein absolut perfektes Erscheinungsbild!
				</h2>
				<p className="pb-8 text-2xl">
					Wir entfernen effektive sämtliche Verschmutzungen an Ihren Fenstern, Türen und Sonnenschutz und
					sorgen dafür, dass alle Elemente auch lange nach der Reinigung noch glänzen!
					<br />
					<br />
					<b>
						Lassen Sie sich gerne von unseren Experten beraten oder erstellen Sie mithilfe unseres
						Online-Konfigurators ganz einfach selbst Ihr Serviceangebot.
					</b>
				</p>
				<div className="flex justify-center">
					<Link href="/angebot" passHref>
						<button className="mt-9 w-1/2 md:w-1/6 mb-10 select-none font-heading bg-primary p-3 rounded-md text-white text-lg shadow-md hover:shadow-lg hover:bg-primary-light focus:shadow-sm focus:outline-none active:shadow-inner transition-all active:bg-primary-dark duration-150">
							Angebot einholen
						</button>
					</Link>
				</div>
				<div>
					<h3 className="text-2xl py-5 font-black">Vorteile von sauberen Fenstern</h3>
					<p>
						Schmutzige Fenster belasten. Das liegt nicht nur daran, dass Blicke durch staubige, fleckige
						Glasscheiben ein schlechtes Gewissen auslösen können, weil man daran denkt, doch jetzt endlich
						mal wieder zum Putzlappen und Wassereimer zu greifen. Aber nicht jeder kann diese Arbeit zeitnah
						ausführen. Bleiben die Fenster langfristig schmutzig, wirkt sich das nachteilig auf Sie und Ihre
						Fenster auf verschiedenen Wegen bemerkbar.
					</p>
					<h3 className="text-2xl py-5 font-black">Saubere Fenster machen glücklich</h3>
					<p>
						Bei starken Verschmutzungen kommt weniger Licht in den Raum. Das schadet Zimmerplanzen und
						drückt die Stimmung der Hausbewohner. Die Tage erscheinen grauer und trostloser als sie
						eigentlich sind.
					</p>
					<h3 className="text-2xl py-5 font-black">Saubere Fenster fühlen sich gut an</h3>
					<p>
						Schmierige Fingerabdrücke strahlen eine mangelhafte Hygiene aus, auch wenn das nicht immer der
						Fall ist. Trotzdem schaffen die schmutzigen Glasscheiben bewusst oder unbewusst ein Unbehagen in
						uns, selbst wenn es unsere eigenen Abdrücke sind.
					</p>
					<h3 className="text-2xl py-5 font-black">Saubere Fenster halten unerwünschte Besucher fern</h3>
					<p>
						Spinnen und Insekten fühlen sich am schmutzigen Fenster besonders wohl, weil sie dort ungestört
						sind. Ihre Hinterlassenschaften schaden aber den Fenstermaterialien, außerdem lösen sie in
						manchen Menschen Ängste aus.
					</p>
					<h3 className="text-2xl py-5 font-black">Saubere Fenster sparen Geld</h3>
					<p>
						Aggressiver Schmutz greift Oberflächen von Holz- und Kunststoffrahmen sowie Dichtungen an. Zu
						seltene Reinigungen bergen daher das Risiko, dass die Lebensdauer der Fenster deutlich sinkt.
						Das führt dazu, dass Sie sie vorzeitig austauschen müssen.
					</p>
					<h3 className="text-2xl py-5 font-black">Saubere Fenster beugen Schäden an sich selbst vor</h3>
					<p>
						Wer seine Fenster zu selten reinigt, merkt oft gar nicht, dass sie schon beschädigt sind. Aus
						kleinen Schäden, die man eigentlich einfach und günstig beseitigen könnte, wird mit der Zeit ein
						kostspieliges Problem.
					</p>
					<h3 className="text-2xl py-5 font-black">Saubere Fenster machen einen guten Eindruck</h3>
					<p>
						Kommen Besucher vorbei, fühlen sie sich mit ungereinigten Fenstern genauso unwohl wie wir
						selbst. Ohne regelmäßige Reinigungen leiden im Zweifel also sogar Ihre Beziehungen und Ihr Ruf.
					</p>
				</div>
			</div>
			<div className="mx-auto flex  justify-center">
				<Link href="/angebot" passHref>
					<button className="mt-9 w-1/2 md:w-1/6 mb-20 select-none font-heading bg-primary p-3 rounded-md text-white text-lg shadow-md hover:shadow-lg hover:bg-primary-light focus:shadow-sm focus:outline-none active:shadow-inner transition-all active:bg-primary-dark duration-150">
						Angebot einholen
					</button>
				</Link>
			</div>
		</>
	);
};

export default Page;
